import { ScreenSizeStateContext } from "../../contexts/screen-size-context-provider";
import { useContextSafely } from "../../utils/react-utils";

/**
 * A hook that return the active isDesktop state value for the `ScreenSizeProvider`.
 *
 * @param suppressErrorMessage Suppress console error message when the hook is used without `ScreenSizeValueContext`.
 */
export function useIsDesktop(suppressErrorMessage?: boolean) {
  return useContextSafely(ScreenSizeStateContext, suppressErrorMessage, useIsDesktop.name)?.isDesktop;
}
